import { PaymentsRepaymentsProvidersListData } from '../../../types/generated/pos';
import { flatProviders } from './flatProviders';

export const getProviderIdByCode = (
	providerList: PaymentsRepaymentsProvidersListData['providers'],
	code: string
): string | undefined => {
	const providers = flatProviders(providerList);
	const provider = providers.find((p) => p.code === code);
	return provider?.id;
};
